import React from 'react';
import { DateComponent } from '../../../common/TableReusableColumns';
import { formatSlaTime, getLookupWitHDefaultValue, getTimeDuration, validateDateValue } from '../../../utils/common';
import { useDispatch } from 'react-redux';
import { openCustomModal } from '../../../actions/modal';
import IconToolTip from '../../../common/IconToolTip';
import HardCloseTicket from '../Modal/HardCloseTicket';
import UpdateSignOffNotes from '../Modal/updateSignOffNote';
import { canEditTicket, canHoldOrResumeTicket, eligibleForHardCloseServiceRequest, isIndividualMilestoneStatusInRange, MilestoneSubStatus, MilestoneSubStatusOrder, MilestoneType, progressStatusList, TicketMilestoneEvents, TicketStatus } from '../TicketController';
import StatusLabel from '../../Payments/reusableComponents/StatusLabel';
import moment from 'moment';
import { RemarkForm } from '../../Payments/Modals/EditPayout/EditPayoutTable';
import { holdOrResumeServiceRequest } from '../../../actions/service_request';
import { isMobileView } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { PartnerDetailsPopUp } from '../TodayStatus/PartnerDetailsPopUp';

export const ProgressColumn = getLookupWitHDefaultValue({
    lookup: {
        OPEN: { color: 'bg-scogoorange', percentage: 10 },
        TRIGGERED: { color: 'bg-scogoorange', percentage: 30 },
        IN_PROGRESS: { color: 'bg-scogoorange', percentage: 50 },
        ON_HOLD: { color: 'bg-scogoclosed', percentage: 50 },
        REJECTED: { color: 'bg-scogoclosed', percentage: 50 },
        CLOSED: { color: 'bg-scogogoing', percentage: 100 },
        COMPLETED: { color: 'bg-scogogoing', percentage: 100 }
    },
    defaultValue: { color: 'bg-scogoorange', percentage: 10 }
})

export const RenderRemark = ({ ticket, signoffRemark, showHardIcon = false, hardCloseTicketModal = () => { } }) => {
    const dispatch = useDispatch();

    let enableSignoffRemark = canEditTicket(ticket);

    if (ticket.milestones) {
        enableSignoffRemark = ticket.milestones.find((milestone) => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED));
    }

    const updateSignOffNotesModal = () => {
        let heading = <span className='text-black'>Update SignOff Notes </span>;
        const findRaisedMilestone = ticket.milestones.filter(milestone => isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.SIGN_OFF_REQUESTED)).map(({ id }) => id);
        const milestones = ticket.milestones.filter(({ id }) => findRaisedMilestone.includes(id));
        let modalComponent = <UpdateSignOffNotes ticketId={ticket.id} signoffRemark={signoffRemark} milestones={milestones} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    };

    return (
        <div className='flex gap-1 w-full items-center mt-1'>
            {signoffRemark && (
                <div className='max-w-8/8'>
                    <StatusLabel titleText='Signoff Remark' content={signoffRemark.remark} color={'scogosuccess'} />
                </div>
            )}
            {enableSignoffRemark && (
                <IconToolTip title='Edit Signoff Remark'>
                    <span className='h-7 w-auto text-center material-icons cursor-pointer font-medium rounded-full text-font12 p-1 bg-scogobgsky text-white ' onClick={updateSignOffNotesModal}>
                        edit
                    </span>
                </IconToolTip>
            )}
            {showHardIcon && (
                <IconToolTip title='Hard Close'>
                    <span
                        className='material-icons cursor-pointer font-medium rounded-full text-font13 p-1 bg-scogoclosed text-white'
                        onClick={() => {
                            hardCloseTicketModal();
                        }}
                    >
                        not_interested
                    </span>
                </IconToolTip>
            )}
        </div>
    );
};

export const getResolutionTime = (ticket) => {
    let resolution_time = ``;
    let startDate = validateDateValue(ticket?.created_at) || validateDateValue(ticket?.execution_date) || validateDateValue(ticket?.planned_date)
    let endDate = validateDateValue(ticket?.site_completed_on) || validateDateValue(ticket?.job_sign_off_date);

    if (startDate && endDate) {
        resolution_time = getTimeDuration(startDate, endDate);
    }
    return resolution_time;
};

const getTicketBroadCastSince = (broadcast_timestamp) => {
    let date = moment(broadcast_timestamp);
    let text = ''
    if (moment().isSame(date, 'day')) {
        let hours = moment(new Date()).diff(date, 'hours');
        text = `${hours} hrs ago`;
    } else {
        let days = moment(new Date()).diff(date, 'days');
        text = `${days} days ago`;
    }
    return text
}

export const ProgressBar = ({ ticket }) => {
    const dispatch = useDispatch();
    let daysLeft = getResolutionTime(ticket);
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);

    let showPauseIcon = canHoldOrResumeTicket(ticket) && ticket.status !== TicketStatus.ON_HOLD;
    let showPlayIcon = canHoldOrResumeTicket(ticket) && ticket.status === TicketStatus.ON_HOLD;
    let showHardIcon = canEditTicket(ticket) && eligibleForHardCloseServiceRequest(ticket.milestones, ticket.status);

    const openHoldTicketModal = () => {
        const formName = 'hold';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Hold Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='HOLD' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {

                let p = { ticketId: ticket.id, state: 'hold' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                }
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });

    };

    const openResumeTicketModal = () => {
        const formName = 'resume';
        const openRemarkPopup = ({ formName, onClick }) => {
            dispatch(
                openCustomModal({
                    heading: 'Resume Ticket Remark',
                    modalHeight: 'auto',
                    modalWidth: '40rem',
                    modalComponent: <RemarkForm formName={formName} onClick={onClick} org_id={ticket.org_id} category='RESUME' />
                })
            )
        }

        return openRemarkPopup({
            formName,
            onClick: ({ processed_remark }) => {
                let p = { ticketId: ticket.id, state: 'resume' };
                let remark = {};
                if (processed_remark?.value) {
                    remark.remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        remark.master_remark_id = processed_remark.value;
                    }
                };
                p.remark = remark;
                dispatch(holdOrResumeServiceRequest({
                    payload: p,
                    formName
                }));
            }
        });
    };

    const hardCloseTicketModal = () => {
        const miles = (ticket?.milestones || []).filter((mile) => isIndividualMilestoneStatusInRange(mile, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_REJECTED));
        let heading = <span className='text-black'>
            Hard Close Ticket :&nbsp;<span className='text-scogobgsky text-font16'>{ticket?.ticket_number}</span>
        </span>;
        let modalComponent = <HardCloseTicket id={ticket.id} milestones={miles} agents={ticket.agents} />;
        let modalHeight = 'auto',
            modalWidth = isMobileView ? '35rem' : '50rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    };

    let startDate = validateDateValue(ticket?.created_at) || validateDateValue(ticket?.planned_date);
    let endDate = ticket?.milestones?.filter((mile) => mile?.closed_at)?.reduce((min, mile) => {
        const closedAt = moment(mile?.closed_at);
        return !min || (closedAt?.isValid() && closedAt.isBefore(min)) ? closedAt : min;
    }, null);

    let sla = 0;
    if (startDate && endDate) {
        const duration = moment.duration(moment(endDate).diff(moment(startDate)));
        const milliseconds = duration.asMilliseconds();

        if (milliseconds < 0) {
            sla = 8.64e+7;
        } else {
            sla = milliseconds;
        }
    }

    const broadCastTime = validateDateValue(ticket.broadcast_timestamp) && getTicketBroadCastSince(ticket.broadcast_timestamp);
    const signoffRemark = ticket.remarks && ticket.remarks.find((remark) => remark.action === TicketMilestoneEvents.MILESTONE_SIGN_OFF_REQUESTED);
    const requesterName = ticket.requested?.display_name || ticket?.requester_name;

    return (
        <div className='w-full text-font11'>
            <p className='td_p_light_primary md:mt-2 mt-0 md:mr-0 mr-2 md:hidden block'>Progress :</p>
            <div className="flex items-center justify-between gap-2">
                {/* Created By at start, Created At at end, minimal w/full */}
                {requesterName ? (
                    <div className="flex items-center min-w-0 flex-shrink-0">
                        <span className='text-scogogray font-medium mr-1'>Created By:</span>
                        <PartnerDetailsPopUp
                            userId={ticket.requested?.id || ticket.requester_id}
                            displayName={`${requesterName}`}
                            onHovertitle={`Created By:  ${requesterName}`}
                            className="truncate max-w-[8rem] text-scogobgsky cursor-pointer text-left text-font10 font-medium hover:text-scogoorange"
                        />
                    </div>
                ) : null}
                <div className={`flex items-center min-w-0 flex-shrink-0 whitespace-nowrap ${requesterName ? 'ml-auto' : ''}`}>
                    <span className='text-scogogray font-medium mr-1'>Created:</span>
                    <DateComponent className='text-font10' date={ticket.created_at} timeFormat='DD MMM YYYY' />
                </div>
            </div>
            <div className='flex mt-1 justify-between items-end '>
                <div className='flex gap-2 items-center'>
                    {startDate && moment(startDate).isValid() && <DateComponent date={startDate} timeFormat='DD MMM YYYY' />}
                    {broadCastTime && <IconToolTip title='Broadcast Time'>
                        <span className='text-font09 text-scogogray flex items-start'>
                            (BR - {broadCastTime})
                        </span>
                    </IconToolTip>}
                </div>
                <div>
                    <p className='td_p_light mx-auto'>{daysLeft}</p>
                </div>
                <div className=''>{endDate && moment(endDate).isValid() && <DateComponent date={endDate} timeFormat='DD MMM YYYY' />}</div>
            </div>
            <div className='bg-scogoeee w-full relative h-2.5 rounded-md mt-1'>
                <div style={{ width: `${ProgressColumn[ticket.status].percentage}%` }} className={`${ProgressColumn[ticket.status].color} absolute top-0 h-2.5 z-0  rounded-md`}></div>
            </div>

            {!signoffRemark && <div className='mt-1 flex items-center w-full'>
                <div className='mr-2 w-full'>
                    <div className='w-full flex items-center'>
                        <div className='w-4/5 pr-2 pt-2 flex gap-x-2 mb-1'>
                            {showPauseIcon && (
                                <IconToolTip title='Hold Ticket'>
                                    <span
                                        className='material-icons cursor-pointer rounded-full text-font13 p-1 bg-scogoprimary text-white'
                                        onClick={() => {
                                            openHoldTicketModal();
                                        }}
                                    >
                                        pause
                                    </span>
                                </IconToolTip>
                            )}
                            {showPlayIcon && (
                                <IconToolTip title='Resume Ticket'>
                                    <span
                                        className='material-icons cursor-pointer rounded-full text-font13 p-1  bg-scogoorange text-white'
                                        onClick={() => {
                                            openResumeTicketModal();
                                        }}
                                    >
                                        play_arrow
                                    </span>
                                </IconToolTip>
                            )}
                            {showHardIcon && (
                                <IconToolTip title='Hard Close'>
                                    <span
                                        className='material-icons cursor-pointer font-medium rounded-full text-font13 p-1 bg-scogoclosed text-white'
                                        onClick={() => {
                                            hardCloseTicketModal();
                                        }}
                                    >
                                        not_interested
                                    </span>
                                </IconToolTip>
                            )}

                            {/* {progressStatus?.label &&
                                (typeof progressStatus.label === 'function' ? (
                                    progressStatus.label(ticket, { onClick: () => { } })
                                ) : (
                                    <div className='truncate'>
                                        <StatusLabel titleText='Status' content={statusContent} color={statusColor} />
                                    </div>
                                ))} */}
                        </div>
                    </div>
                </div>
            </div>}
            {signoffRemark && <RenderRemark ticket={ticket} signoffRemark={signoffRemark} showHardIcon={showHardIcon} hardCloseTicketModal={hardCloseTicketModal} />}
            {sla ? <RenderSLA milliseconds={sla} /> : <></>}
        </div>
    );
};


const RenderSLA = ({ milliseconds }) => {
    return <div className='flex text-font13'>
        <p className='td_p_dark'>
            <span className='td_p_light text-md'> SLA: </span> {`${formatSlaTime(milliseconds)}`}
        </p>
    </div>
}